import React from 'react'
import { Card, IOption } from '@ss/meta-core-components'
import styled from '@emotion/styled'
import { GlobalData, LayersData } from '@types'
import { Bar } from '@components'

interface Props {
  global?: GlobalData
  field?: IOption | null
  layers?: LayersData
  selectedAggregation: string
}

const labels: { [key: string]: string } = {
  value_count: 'COUNT',
  min: 'MINIMUM',
  max: 'MAXIMUM',
  avg: 'AVERAGE',
  sum: 'SUM',
}
/**
 * Componente Globale stats per la pagina comparison
 * @param global {GlobalData=} dati che popolano la tabella
 * @param field {IOption=} campo su cui basare le ricerche
 * @param layers {LayersData=} dati per il grafico
 * @param selectedAggregation {string} aggregazione selezionata
 * @component
 */
export const GlobalStats: React.FC<Props> = ({
  global,
  field,
  layers,
  selectedAggregation,
}) => {
  return (
    <Card width={'100%'} height={'100%'}>
      <Content data-cy={'comparison-global-stats-container'}>
        <Title>GLOBAL STATISTICS - {field?.label?.toUpperCase() || ''}</Title>
        <DataContainer>
          <Table data-cy={`comparison-global-table`}>
            <Row>
              <Cell></Cell>
              <Cell> START-UP </Cell>
              <Cell> IMPRESE </Cell>
            </Row>
            {global ? (
              Object.keys(global.startup).map((key, index) => (
                <Row key={`global-${key}`}>
                  <Cell>{labels[key] || ''}</Cell>
                  <Cell>{global.startup[key]}</Cell>
                  <Cell>{global.impresa[key]} </Cell>
                </Row>
              ))
            ) : (
              <></>
            )}
          </Table>
          <ChartContainer data-cy={`comparison-global-chart`}>
            <ChartTitle>{labels[selectedAggregation]}</ChartTitle>
            <Bar
              dimensions={{ height: '450px' }}
              bin={
                layers
                  ? layers[selectedAggregation as keyof LayersData]?.length
                  : 0
              }
              barPadding={0.4}
              indexBy={'category'}
              layout={'horizontal'}
              data={
                layers
                  ? layers[selectedAggregation as keyof LayersData]?.sort(
                      function (
                        a: { category: string },
                        b: { category: string }
                      ) {
                        if (a.category > b.category) {
                          return -1
                        }
                        if (b.category > a.category) {
                          return 1
                        }
                        return 0
                      }
                    )
                  : []
              }
              margin={{ top: 10, right: 20, bottom: 70, left: 150 }}
              keys={['startup', 'impresa']}
              customColors={['#9F8FDD', '#2D9CDB']}
              groupMode={'grouped'}
              customLegend={[
                {
                  anchor: 'bottom',
                  direction: 'row',
                  justify: false,
                  translateX: -60,
                  translateY: 60,
                  itemsSpacing: 2,
                  itemWidth: 100,
                  itemHeight: 20,
                  itemDirection: 'left-to-right',
                  itemOpacity: 0.85,
                  symbolSize: 18,
                  symbolShape: 'circle',
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemOpacity: 1,
                      },
                    },
                  ],
                },
              ]}
            />
          </ChartContainer>
        </DataContainer>
      </Content>
    </Card>
  )
}

//region style
const Content = styled.div`
  display: grid;
  grid-template-rows: 22px auto;
  gap: 10px;
`
const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
`
const DataContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 7fr;
  gap: 10px;
`
const Table = styled.div`
  display: grid;
  width: 80%;
  place-self: center;
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
`
const Cell = styled.div`
  place-self: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 27px;
  text-transform: uppercase;
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
`
const ChartContainer = styled.div`
  display: grid;
  grid-template-rows: 30px auto;
`

const ChartTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  place-self: center;
`
//endregion
